module.exports = __webpack_public_path__ + "static/media/Sharp-LCD-Specification-LQ121S1LG88 6-26-12.c25388d7.pdf";